import React, { PureComponent } from 'react';
import {
  Card, CardBody, Col, Button, ButtonToolbar, Progress
} from 'reactstrap';  
import { reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { check, updateGeologiaShapeProtecaoIntegralFile } from "../../Services/GeologiaShapeFileProtecaoIntegralService";
import { checkKey } from "../../Services/SecurityService";
//import {  } from "../../Services/GeometryShapes";
import { FullWideNotification } from '../../../shared/components/Notification';
import NotificationSystem from 'rc-notification';
import { util } from "../../../shared/util";
import shp from "shpjs";

let notificationTC = null;

let estadosFiles = {};
let geologias2 = [];
let shapeFile = [];
let totalGeologias = 0;
let contGeologias = 0;
const LIMITE = 100;


const rootGeologias = `${process.env.PUBLIC_URL}/19/shp/protecaointegral/`;

class CrudEdit extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      carregarShapes: true,
      next: true,
      clicked: false,

      canceled: false,

      processingStatus: 0,
      processingStatusInfo: 1,
      tempoRestante: '',

      estados: {},
      files: [],
      geologies: [],

      data: {
        geologiaShapeFileProtecaoIntegral: null,
        geometryShapeProtecaoIntegral: null
      }
    };
    check();

    this.loadShapes = this.loadShapes.bind(this);
    this.loadZipfile = this.loadZipfile.bind(this);
    this.process = this.process.bind(this);
  }

  process(requestList, index, length){
    let inicio = performance.now();
    let fim = 0;
    let diff = 0;
    let tempo = 0;
    let tempoRestante = "";
    // console.log("inicio: " + inicio);
    updateGeologiaShapeProtecaoIntegralFile(requestList[index])
    .then(obj => {
      if(obj !== null && obj !== undefined){
        if(obj.erros === null || obj.erros === undefined || obj.erros.length === 0){
          contGeologias += requestList[index].protecaoIntegralList.length;
          let processingStatus = (contGeologias /  (totalGeologias+1)) * 100;

          fim = performance.now();
          diff = fim - inicio;
          tempo = diff * (((totalGeologias+1)-contGeologias)/LIMITE);
          tempoRestante = util.formatMiliseconds(tempo);

          // console.log("fim: " + fim);
          // console.log("diff: " + diff);
          // console.log("tempo total em milissegundos: " + tempo);
          // console.log("tempoRestante: " + tempoRestante);

          this.setState({ processingStatus: processingStatus.toFixed(2), tempoRestante });

          if(index === length){
            this.props.updateTable(obj, this.props.t('forms.dataUpdateSuccess'));
            setTimeout(
              () => this.props.updateTable(false), 
              1000
            );
          }else{
            if(!this.state.canceled){
              this.process(requestList, index+1, length);
            }
          }
          
        }else{
          this.setState({ clicked: false });
          //console.log(obj.erros);
        }
      } else {
        this.setState({ clicked: false });
        if(obj.errors === undefined){
          this.show('danger', this.props.t('forms.dataUpdateError'));
        } else {
          this.show('danger', obj.errors[0].defaultMessage);
        }
      }
    });
  }

  handleSubmit(e){
    if(this.state.next){
      this.setEstados();
    }else{
      this.setState({ clicked: true });
      let requestList = [];

      totalGeologias = geologias2.length-1;
      contGeologias = -1;
      while(contGeologias < totalGeologias){
        let request = {
          protecaoIntegralList: []
        };
        if(contGeologias < 0){
          contGeologias++;
          request.protecaoIntegralList.push(geologias2[contGeologias]);
        }else{
          for(let g = 0; g < LIMITE; g++){
            contGeologias++;
            request.protecaoIntegralList.push(geologias2[contGeologias]);
            if(contGeologias + 1 > totalGeologias){
              break;
            }
          }
        }
        requestList.push(request);
      }
      contGeologias = 0;
      // console.log(requestList);
      this.process(requestList, 0, requestList.length-1);
    }
  }

  setEstados(){
    //console.log("setEstados");
    if(geologias2 !== null && geologias2 !== undefined && geologias2.length > 0){
      let uf;
      let total = geologias2.length;
      //console.log("Estados não encontradas: ");
      for(let i = 0; i < total; i++){
        // if(geologias2[i].geologiaShapeFileProtecaoIntegral.estado !== null && 
        //     geologias2[i].geologiaShapeFileProtecaoIntegral.estado !== undefined && 
        //     geologias2[i].geologiaShapeFileProtecaoIntegral.estado.id != null && 
        //     geologias2[i].geologiaShapeFileProtecaoIntegral.estado.id != undefined &&
        //     geologias2[i].geologiaShapeFileProtecaoIntegral.estado.id > 0){
        //       geologias2[i].estado = geologias2[i].geologiaShapeFileProtecaoIntegral.estado;
        //       geologias2[i].geometryShapeProtecaoIntegral[0].estado = geologias2[i].estado;
        //       geologias2[i].geologiaShapeFileProtecaoIntegral.estado = geologias2[i].estado;
        // }else{
        //   uf = geologias2[i].geologiaShapeFileProtecaoIntegral.name.substring(0,2);
        //   let estado = this.state.estados.get(uf.toLowerCase());
        //   //if(estado != null && estado != undefined){
        //   geologias2[i].estado = estado;
        //   geologias2[i].geometryShapeProtecaoIntegral[0].estado = geologias2[i].estado;
        //   geologias2[i].geologiaShapeFileProtecaoIntegral.estado = geologias2[i].estado;
        //   //}
        // }
        let processingStatus = ((i+1) /  total) * 100;
        this.setState({ processingStatus: processingStatus.toFixed(2) });
      }
      setTimeout(
        () => this.setState({ processingStatus: 0, processingStatusInfo: this.state.processingStatusInfo+1 }), 
        1000
      );
    }
    //console.log(geologias2);
    this.setState({next: false});
  }

  // getEstados(file){
  //   let estadoEstado = {
  //     estado: null,
  //     estado: null
  //   }
  //   if(file.estado != null && file.estado != undefined && file.estado.id > 0 &&
  //     file.estado != null && file.estado != undefined && file.estado.id > 0){
  //       estadoEstado = {
  //         estado: file.estado,
  //         estado: file.estado
  //       }
  //   }else{
  //     let ce = [];
  //     let name = file.name.substring(0,2) + "#" + file.name.substring(3);
  //     ce = name.split("#");
  //     name = ce[0]+"-"+util.getTextNormalized(ce[1]);//ba-ibiassuce.shp
  //     let city = this.state.estados.get(name.toLowerCase());//ba-ibiassuce
  //     //console.log(city);
  //     try{
  //       estadoEstado = {
  //         estado: city,
  //         estado: city.estado
  //       }
  //     }catch{
  //       console.log("catch: " + name.toLowerCase());
  //     }
  //   }
  //   return estadoEstado;
  // }

  loadShapes(){
    //this.loadFileNames("g");
    //this.loadFileNames("r");
    let total = this.state.files.length;
    if(total > 0){
      for(let i = 0; i < total; i++){
        this.loadZipfile(this.state.files[i]);

        let processingStatus = ((i+1) /  total) * 100;
        this.setState({ carregarShapes: false, processingStatus: processingStatus.toFixed(2) });
      }
      setTimeout(
        () => this.setState({ processingStatus: 0, processingStatusInfo: this.state.processingStatusInfo+1 }), 
        1000
      );
    }
  }

  loadZipfile(file) {
    let path = rootGeologias.concat(file.name).concat(".zip");
    
    try {
      shp(path).then(function (shapes) {
        console.log("shapes:");
        console.log(shapes);
        let list = [];
        if(shapes.length != undefined && shapes.length != null && shapes.length > 0){
          list = shapes;
        }else{
          list.push(shapes);
        }
        
        let totalFeatures = 0;
        let filename = "";
        for(let dta = 0; dta < list.length; dta++){
          let data = list[dta];
          filename = data.fileName.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
          totalFeatures = data.features.length;
          let protecaoIntegralParsed = null;
          
          for(let i = 0; i < totalFeatures; i++){

            let geometry = {
              id: '',
              protecaoIntegral: null,
              cidade: null,
              estado: null,
              status: "ATIVO",
              deleted: false,
              bbox: null,
              coordinates: null,
              coordinatesMulti: null,
              bboxList: [],
              coordinatesList: [],
              coordinatesMultiList: []
            };
            
            let bboxList = data.features[i].geometry.bbox;
            if(bboxList != null && bboxList != undefined && bboxList.length > 0){
              for(let m = 0; m < bboxList.length; m += 2){
                geometry.bboxList.push({
                  lat: bboxList[(m+1)],
                  lng: bboxList[m]
                });
              }
            }

            let type = data.features[i].geometry.type;
            let coordinatesList = data.features[i].geometry.coordinates;
            if(coordinatesList != null && coordinatesList != undefined && coordinatesList.length > 0){
              if(type === "Polygon"){
                for(let j = 0; j < coordinatesList.length; j++){
                  let coordinates = coordinatesList[j];
                  for(let m = 0; m < coordinates.length; m++){
                    geometry.coordinatesList.push({
                      lat: coordinates[m][1],
                      lng: coordinates[m][0]
                    });
                  }
                }
              }else if(type === "MultiPolygon"){
                for(let j = 0; j < coordinatesList.length; j++){
                    let coordinatesAux = coordinatesList[j];
                    for(let c = 0; c < coordinatesAux.length; c++){
                      let coordinates = coordinatesAux[c];
                      let coordList = [];
                      for(let m = 0; m < coordinates.length; m++){
                          coordList.push({
                          lat: coordinates[m][1],
                          lng: coordinates[m][0]
                          });
                      }
                      geometry.coordinatesMultiList.push(coordList);
                    }
                }
              }
            }
            //montou a geologia

            let properties = data.features[i].properties;
            if(properties != null && properties != undefined){
              protecaoIntegralParsed = {
                id: '',
                name: properties.nome || '',
                nameAbreviado: properties.nomeabrev || '',
                sigla: properties.sigla || '',
                tipoUnidade: properties.tipounidpr || '',
                info: '',
                atoLegal: properties.atolegal || '',
                anoCriacao: properties.anocriacao || '',
                administracao: properties.administra || '',
                area: properties.area || properties.Area || '',
                acres: properties.Acres || '',
                hectares: properties.Hectares || '',
                perimetro: properties.Perimeter || '',
                status: "ATIVO",
                deleted: false,
                createdAt: '',
                updatedAt: ''
              }
            }

            protecaoIntegralParsed.geologiaShapeFileProtecaoIntegral = {
              createdAt: file.createdAt,
              deleted: file.deleted,
              estado: file.estado,
              extension: file.extension,
              id: file.id,
              name: filename,
              filename: file.name + ".zip",
              geometries: totalFeatures,
              geometriesLidas: 0,
              size: file.size,
              statusLoad: file.statusLoad,
              type: file.type,
              updatedAt: file.updatedAt,
              start: false
            }
            //console.log(geologiaParsed.geologiaShapeFile);
            protecaoIntegralParsed.geometryShapeProtecaoIntegral = [];
            protecaoIntegralParsed.geometryShapeProtecaoIntegral.push(geometry);

            geologias2.push(protecaoIntegralParsed);
          }
        }
        // console.log("geologias:");
        // console.log(geologias2);
      });
    } catch (err) {
      console.log(err);
    }
  }
  
  loadData(files, estados) {
    if(files !== undefined && files !== null && files.length > 0 &&
        estados !== undefined && estados !== null && estados.size > 0){
        this.setState({ 
          files,
          estados
        }, () => {});
    }
  }

  countPolygon(type, list){
    let total = 0;
    if(type === "P"){
      total = list.length;
    }else{
      for(let i = 0; i < list.length; i++){
        total += list[i].length;
      }
    }
    return total;
  }

  componentDidMount() {
    checkKey("MENU_GEOLOGY_SHP_PROTECAO_INTEGRAL_PROCESSING");
    
    const { files, estados} = this.props;
    this.loadData(files, estados);
    NotificationSystem.newInstance({ style: { top: 65 } }, n => notificationTC = n);
  }

  componentDidUpdate(props, state) {
    if(props.files !== this.props.files || props.estados !== this.props.estados){
      this.loadData(this.props.files, this.props.estados);
    }
  }

  componentWillUnmount() {
    notificationTC.destroy();
  }

  clear(canceled){
    const data = { ...this.state.data }
    data['geologiaShapeFileProtecaoIntegral'] =  null;
    data['geometryShapeProtecaoIntegral'] =  null;
    this.setState({ 
      data,
      estados: {},
      files: [],
      geologies: [],
      canceled
    }, () => {});
  }

  cancel(event) {
    this.clear(true);
    this.props.updateTable(false);
  }

  show = (color, message) => {
    return notificationTC.notice({
      content: <FullWideNotification
        color={color}
        message={message}
        />,
      duration: 3,
      closable: true,
      style: { top: 0, left: 0 },
      className: `full ltr-support`,
    });
  };

  render() {
    const { t } = this.props;
    const { files, carregarShapes, clicked, processingStatus, processingStatusInfo, tempoRestante } = this.state;

    let geologiaShapeFileProtecaoIntegral = [];
    if(this.state.next){
      let total = files.length;
      if(total > 0){
        for(let i = 0; i < total; i++){
          geologiaShapeFileProtecaoIntegral.push(
            <div key={"divshapes_"+i} className='form__form-inline' style={{width: '100%', borderBottom: '1px solid #cccccc'}}>
              <label 
                key={"labelshapes_"+i}
                style={{margin: 0, width: '100%'}}>
                {files[i].name}
              </label>
              <label 
                key={"labelshapes2_"+i}
                style={{margin: 0, }}>
                {t('forms.geologias')}
              </label>
            </div>
          );
        }
      }
    }else{
      let exists = false;
      shapeFile = [];
      let total = geologias2.length;
      let maxSimbs = 20;
      if(total > 0){
        for(let i = 0; i < total; i++){
          //console.log("ini for name => " + geologias2[i].geologiaShapeFileProtecaoIntegral.name);
          if(shapeFile.length === 0){
            let shp = {
              name: geologias2[i].geologiaShapeFileProtecaoIntegral.name,
              states: [],
              simbs: [],
              full: false
            };
            geologias2[i].geologiaShapeFileProtecaoIntegral.start = true;
            //console.log("ini =>  " + shp.name);
            if(geologias2[i].geometryShapeProtecaoIntegral[0].coordinatesList.length > 0){
              shp.states.push(geologias2[i].geologiaShapeFileProtecaoIntegral.name + " (Polygon coords: " + this.countPolygon("P", geologias2[i].geometryShapeProtecaoIntegral[0].coordinatesList) + ")");
            }else{
              shp.states.push(geologias2[i].geologiaShapeFileProtecaoIntegral.name + " (MultiPolygon coords: " + this.countPolygon("M", geologias2[i].geometryShapeProtecaoIntegral[0].coordinatesMultiList) + ")");
            }
            shp.simbs.push(geologias2[i].geologiaShapeFileProtecaoIntegral.name);
            shapeFile.push(shp);
          }else{
            //console.log("demais =>  " + geologias2[i].geologiaShapeFileProtecaoIntegral.name);
            exists = false;
            for(let j = 0; j < shapeFile.length; j++){
              //console.log(geologias2[i].geologiaShapeFileProtecaoIntegral.name + " === " + shapeFile[j].name);
              if(geologias2[i].geologiaShapeFileProtecaoIntegral.name === shapeFile[j].name){
                exists = true;
                //console.log("Igual");
                if(shapeFile[j].states.length < maxSimbs){
                  if(geologias2[i].geometryShapeProtecaoIntegral[0].coordinatesList.length > 0){
                    shapeFile[j].states.push(geologias2[i].geologiaShapeFileProtecaoIntegral.name + " (Polygon coords: " + this.countPolygon("P", geologias2[i].geometryShapeProtecaoIntegral[0].coordinatesList) + ")");
                  }else{
                    shapeFile[j].states.push(geologias2[i].geologiaShapeFileProtecaoIntegral.name + " (MultiPolygon coords: " + this.countPolygon("M", geologias2[i].geometryShapeProtecaoIntegral[0].coordinatesMultiList) + ")");
                  }
                  if(!shapeFile[j].simbs.includes(geologias2[i].geologiaShapeFileProtecaoIntegral.name)){
                    shapeFile[j].simbs.push(geologias2[i].geologiaShapeFileProtecaoIntegral.name);
                  }
                  shapeFile[j].states = shapeFile[j].states.sort((a, b) => (a > b) ? 1 : -1);
                }else{
                  if(!shapeFile[j].full){
                    shapeFile[j].states.push("...");
                    shapeFile[j].full = true;
                  }
                }
                break;
              }
            }
            //console.log("saiu do for => " + geologias2[i].geologiaShapeFileProtecaoIntegral.name + " === " + exists);
            if(!exists){
              //console.log("não existe => " + geologias2[i].geologiaShapeFileProtecaoIntegral.name);
              let shp = {
                name: geologias2[i].geologiaShapeFileProtecaoIntegral.name,
                states: [],
                simbs: [],
                full: false
              }
              geologias2[i].geologiaShapeFileProtecaoIntegral.start = true;
              //console.log("novo =>  " + shp.name);
              if(geologias2[i].geometryShapeProtecaoIntegral[0].coordinatesList.length > 0){
                shp.states.push(geologias2[i].geologiaShapeFileProtecaoIntegral.name + " (Polygon coords: " + this.countPolygon("P", geologias2[i].geometryShapeProtecaoIntegral[0].coordinatesList) + ")");
              }else{
                shp.states.push(geologias2[i].geologiaShapeFileProtecaoIntegral.name + " (MultiPolygon coords: " + this.countPolygon("M", geologias2[i].geometryShapeProtecaoIntegral[0].coordinatesMultiList) + ")");
              }
              shp.simbs.push(geologias2[i].geologiaShapeFileProtecaoIntegral.name);
              shapeFile.push(shp);
            }
          }
        }
        
        for(let i = 0; i < shapeFile.length; i++){
          let simbs = [];
          for(let j = 0; j < shapeFile[i].states.length; j++){
            simbs.push(
              <div key={"labelshapesdiv_"+i+"_"+j} className='form__form-inline' 
                style={{width: 'auto', backgroundColor: 'rgb(190 255 190 / 35%)', border: '1px solid', 
                borderColor: 'rgb(36 140 36 / 35%)', paddingLeft: '3px', paddingRight: '3px', marginRight: '10px', marginBottom: '10px' }}>
                <label 
                  key={"labelshapes2_"+i}
                  style={{margin: 0, }}>
                  {shapeFile[i].states[j]}
                </label>
              </div>
            );
          }

          geologiaShapeFileProtecaoIntegral.push(
            <div key={"divshapes_"+i} className="form__form-inline" 
                  style={{height: 'auto', width: '100%', borderBottom: '1px solid #cccccc'}}>
              <label 
                key={"labelshapes_"+i}
                style={{margin: 0, width: '100%'}}>
                {shapeFile[i].name + ": " + shapeFile[i].states.length + " Shapes e " + shapeFile[i].simbs.length + " Geologias"}
              </label>
              <div key={"divshapes_simbs"+i} className="form__form-group-field" 
                  style={{width: '100%', display: 'flow-root', flexWrap: 'wrap'}}>
                    {simbs}
              </div>
            </div>
          );
        }
      }
    }

    return (
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            <div className="form__form-group">
              <h3 className="page-subhead subhead">{t('forms.toProcess')}</h3>
            </div>
            <div className="form">

              <div className="form__form-group">
                <span title={t('forms.requiredField')} className="form__form-group-label">
                  {t('forms.processingStatus') + " - " + t('forms.processingStatusInfo_'+processingStatusInfo) + ": " + processingStatus + " % (" + t('forms.timeLeft') + ": " + tempoRestante + ")"} 
                </span>
                <div key="div1" className="progress-wrap progress-wrap--big">
                  <Progress key="progress1" animated value={processingStatus} />
                </div>
                <div className="form__form-group-field" 
                  style={{border: '1px solid #CCCCCC', height: '160px', overflowY: 'auto', 
                          display: 'flow-root', flexWrap: 'wrap', paddingTop: '5px', paddingLeft: '5px'}}>
                  
                  {geologiaShapeFileProtecaoIntegral}

                </div>
              </div>
              
              <ButtonToolbar className="form__button-toolbar">
                <Button color="primary" type="submit"
                  onClick={e => this.loadShapes()}
                  disabled={!carregarShapes}>
                  {t('forms.loadShapes')}
                </Button>
                <Button color="primary" type="submit"
                  onClick={e => this.handleSubmit(e)}
                  disabled={carregarShapes || clicked}>
                  {this.state.next ? t('forms.synchronize') : t('forms.save') }
                </Button>
                <Button type="button" onClick={e => this.cancel(e)}>
                  {t('forms.cancel')}
                </Button>
              </ButtonToolbar>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

export default withTranslation('common')(CrudEdit);